import { render } from "./device.vue?vue&type=template&id=49710d40"
import script from "./device.js?vue&type=script&lang=js"
export * from "./device.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__